import { Tag, TagLabel } from "~/react/ui/tag"
import { CurrencyHelper } from "~/helpers/currency_helper"
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from "~/react/ui/hover-card"
import { Separator } from "~/react/ui/separator"

type OrderSummaryPopoverProps = {
  selectedDomainsCount: number
  domainsTotalPriceCents: number
  emailAccountsCount: number
  emailAccountsTotalPriceCents?: number
  currencyCode?: string
}

export function OrderSummaryPopover({
  selectedDomainsCount,
  domainsTotalPriceCents,
  emailAccountsCount,
  emailAccountsTotalPriceCents,
  currencyCode,
}: OrderSummaryPopoverProps) {
  const hasDomains = selectedDomainsCount > 0 && domainsTotalPriceCents > 0
  const hasEmailAccounts =
    !!emailAccountsTotalPriceCents && emailAccountsCount > 0

  if (!hasDomains && !hasEmailAccounts) return null

  const title = i18n.t("js.email_accounts.provisioning.order_summary_title")
  const totalLabel = i18n.t(
    "js.email_accounts.provisioning.order_summary_total_label",
  )
  const domainsLabel = i18n.t(
    "js.email_accounts.provisioning.order_summary_domains_label",
    {
      count: selectedDomainsCount,
    },
  )
  const emailAccountsLabel = i18n.t(
    "js.email_accounts.provisioning.order_summary_accounts_label",
    {
      count: emailAccountsCount,
    },
  )
  const perYear = i18n.t("js.email_accounts.provisioning.per_year")
  const perMonth = i18n.t("js.email_accounts.provisioning.per_month")

  // Prices are already in the user's currency (cents)
  const domainsDisplayCents = hasDomains ? domainsTotalPriceCents : 0
  const emailDisplayCents =
    hasEmailAccounts && emailAccountsTotalPriceCents
      ? emailAccountsTotalPriceCents
      : 0

  const currencySymbol = CurrencyHelper.currencySymbol(currencyCode)

  const domainsPrice = hasDomains
    ? CurrencyHelper.numberToCurrency(domainsDisplayCents / 100, currencySymbol)
    : ""
  const emailAccountsPrice = hasEmailAccounts
    ? CurrencyHelper.numberToCurrency(emailDisplayCents / 100, currencySymbol)
    : ""

  const totalTodayCents = domainsDisplayCents + emailDisplayCents

  if (totalTodayCents <= 0) return null

  const totalToday = CurrencyHelper.numberToCurrency(
    totalTodayCents / 100,
    currencySymbol,
  )

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Tag size="md">
          <TagLabel>{totalToday}</TagLabel>
        </Tag>
      </HoverCardTrigger>
      <HoverCardContent side="bottom" className="email-accounts-order-popover">
        <div className="mb-2 text-xs text-body-secondary">{title}</div>
        {hasDomains && (
          <div className="email-accounts-order-popover__row text-xs">
            <span>{domainsLabel}</span>
            <span>
              {domainsPrice}&nbsp;
              <span className="text-2xs text-body-secondary">
                &nbsp;/&nbsp;{perYear}
              </span>
            </span>
          </div>
        )}
        {hasEmailAccounts && (
          <div className="email-accounts-order-popover__row text-xs">
            <span>{emailAccountsLabel}</span>
            <span>
              {emailAccountsPrice}&nbsp;
              <span className="text-2xs text-body-secondary">
                &nbsp;/&nbsp;{perMonth}
              </span>
            </span>
          </div>
        )}
        <Separator className="my-2" />
        <div className="d-flex justify-content-between text-xs-medium">
          <span>{totalLabel}</span>
          <span>{totalToday}</span>
        </div>
      </HoverCardContent>
    </HoverCard>
  )
}


